import Developers from '@/models/general/settings/Developers';

const getDefaultState = () => ({
  webhookLogs: [],
});
export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setWebhookLogs(state, payload) {
      state.webhookLogs = payload || [];
    },
  },

  actions: {
    async getWebhookLogs({ commit }, payload) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Developers.getWebhookLogs(payload?.query || '');

        commit('setWebhookLogs', data.data.store_event_logs);
        commit('setServerPagination', data.data.pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data);
      }
    },
  },
};
